import React from "react";
import HiringManager from "./sections/HiringManager";
import ImageGallery from "./sections/ImageGallery";
import Team from "./sections/Team";
import Values from "./sections/Values";
import SectionTitle from "./components/SectionTitle";

export default ({
  companyImageGallery,
  hiringManager,
  team,
  values,
  colorHighlightBg,
  colorSectionHeaderText,
  colorSectionText,
  name,
  description,
  setActiveHeader
}) => (
  <div
    className="p-4 -mx-4 overflow-hidden md:-mx-0 md:p-6 xl:p-8"
    style={{ backgroundColor: colorHighlightBg }}
  >
    <SectionTitle title={name} color={colorSectionHeaderText} />
    <div className="space-y-6">
      <section>
        <ImageGallery
          companyImageGallery={companyImageGallery}
          setActiveHeader={setActiveHeader}
        />
      </section>

      <div
        className="prose"
        style={{ color: colorSectionText }}
        dangerouslySetInnerHTML={{ __html: description }}
      />

      {hiringManager.length > 0 && (
        <section>
          <HiringManager
            hiringManager={hiringManager}
            colorSectionHeaderText={colorSectionHeaderText}
            colorSectionText={colorSectionText}
          />
        </section>
      )}

      {team.length > 0 && (
        <section>
          <Team
            team={team}
            colorSectionHeaderText={colorSectionHeaderText}
            colorSectionText={colorSectionText}
            setActiveHeader={setActiveHeader}
          />
        </section>
      )}

      {values.length > 0 && (
        <section>
          <Values
            values={values}
            colorSectionHeaderText={colorSectionHeaderText}
            colorSectionText={colorSectionText}
            setActiveHeader={setActiveHeader}
          />
        </section>
      )}

      {/* {hiringProcess.length > 0 &&
          <section>
            <SectionSubTitle title={`Our ${hiringProcess.length}-Stage Hiring Process`} color={colorSectionHeaderText} />
            <div className="mb-4 xl:mb-6">
              <PageDescription
                description={"Takes up to 2-6 weeks to complete."}
              />
            </div>
            <HiringProcess hiringProcess={hiringProcess} />
          </section>
        } */}
    </div>
  </div>
);
